import { render, staticRenderFns } from "./formUserAccess.vue?vue&type=template&id=3f156ba2&"
import script from "./formUserAccess.vue?vue&type=script&lang=js&"
export * from "./formUserAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports